let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9YR2a")).then(() => parcelRequire('iPNwG'));